module.exports = "<div class=\"droppable-zone\">\n    <div ref=\"dropzone\">\n        <slot></slot>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/templates/droppable-zone.html
// module id = 91
// module chunks = 1